import { Position, State } from 'src/types'
// 背面の描画
import { indexFingerCover } from 'src/features/gorilla/drawer/glove/rightThrow/back/fingerCoverOrPad/indexFingerCover'
import { lace } from 'src/features/gorilla/drawer/glove/rightThrow/back/lace'
import { lining } from 'src/features/gorilla/drawer/glove/rightThrow/back/lining'
import { littleHookDrawer } from 'src/features/gorilla/drawer/glove/rightThrow/back/hooks/littleHook'
import { thumbHook } from 'src/features/gorilla/drawer/glove/rightThrow/back/hooks/thumbHook'
import { backLaceDrawer, gorillaLabelDrawerForGlove } from 'src/features/gorilla/drawer/common/useCanvasHelper'
import { webOfGloveBackDrawer } from 'src/features/gorilla/drawer/glove/rightThrow/back/web/useCanvasWebsBack'
import { liningEmbroideryDrawer, nonThumbEmbroideryDrawer } from 'src/features/gorilla/drawer/common/back/useCanvasEmbroideries'
import { indexFingerCoverTipOut } from 'src/features/gorilla/drawer/glove/rightThrow/back/fingerCoverOrPad/indexFingerCoverTipOut'
import { backStyleOfGloveBackDrawer } from 'src/features/gorilla/drawer/glove/rightThrow/back/backStyles'
import { laceOfWristBeltCrossDrawer } from 'src/features/gorilla/drawer/glove/rightThrow/back/lace/laceOfWristBeltFix'
import { canvasResetter } from 'src/util/canvas'

export const gorillaCanvasGloveBack = (ctx: CanvasRenderingContext2D, state: State, position: Position): void => {
  const isIndexFingerCover = state.fingerGuardType?.value == 'indexCover' || (state.fingerGuardType?.value === 'unselected' && position === 'pitcher')
  const isIndexAndMiddleFingerTipOutCover =
    state.fingerGuardType?.value === 'indexAndMiddleTipOutCover' ||
    (state.fingerGuardType?.value === 'unselected' && state.baseModel.productNumber === 'BKN-20')
  const isMiddleFingerTipOutCover = state.fingerGuardType?.value === 'middleTipOutCover'
  // リセット
  canvasResetter(ctx)
  // 裏革
  lining(ctx, state.linings?.color)

  // 平裏の刺繍描画1段目
  liningEmbroideryDrawer(ctx, state.embroideries, 'first')
  // 平裏の刺繍描画2段目
  liningEmbroideryDrawer(ctx, state.embroideries, 'second')
  // バックスタイルの描画(ハミダシ,親指刺繍含)
  backStyleOfGloveBackDrawer(ctx, state)
  // 指カバー
  isIndexFingerCover && indexFingerCover(ctx, state.indexCover.color, state.stitch.color)
  isIndexAndMiddleFingerTipOutCover && indexFingerCoverTipOut(ctx, state.indexCover.color, state.stitch.color, -90, 70, -10)
  isMiddleFingerTipOutCover && indexFingerCoverTipOut(ctx, state.indexCover.color, state.stitch.color, -155, 85, -13)

  // 中指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'middleFinger', state.embroideries)
  // 薬指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'ringFinger', state.embroideries)
  // 小指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'childFinger', state.embroideries)

  // ウェブの描画
  webOfGloveBackDrawer(ctx, state, position)
  // 革紐
  lace(ctx, state.lace?.color)

  laceOfWristBeltCrossDrawer(ctx, state.lace?.color, state.baseModel.productNumber)

  // 背面紐通し(オプション)
  backLaceDrawer(ctx, state?.backLace?.value, state.lace?.color, position)
  // ラベル描画
  gorillaLabelDrawerForGlove(ctx, state)
  // 小指掛け紐
  littleHookDrawer(ctx, state.littleHook?.color, state.baseModel?.productNumber)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook?.color, 110, -310, 15) // 先端
  thumbHook(ctx, state.thumbHook?.color, -14, 30, 0) //手元
  // circleHollowOutEmbroideryDrawer(ctx, state.embroideries)
}
